import React, {
  useEffect,
  memo,
  useMemo,
  useState,
} from 'react';
import Locale from '@active/react-utils/i18n/Locale';
import CurrencyInput from '@active/react-ui/CurrencyInput';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import isNil from 'lodash/isNil';
import { usePennyRounding } from '../../../../../../../../shared/utils/customizedHooks';
import { amountSum } from '../../../../../../../../shared/utils/commonUtils';
import Currency from '../../../../../../Currency';
import useCrurrencyInput from '../../../utils/useCrurrencyInput';
import { getPennyRounding, updatePaymentsInfoUsedForPay } from '../../../paymentMethodsSlice';

const Cash = ({ paymentMethodType }) => {
  const dispatch = useDispatch();
  const [ cashRefundAmount, setCashRefundAmount ] = useState();

  const {
    refundTotalAmount,
  } = useSelector(state => state.mainStateData);

  const {
    paymentMethodsConfig: {
      isSingleMode = true,
    } = {},
  } = useSelector(state => state.propsData);

  const pennyRounding = useSelector(getPennyRounding);

  const isPrefillValue = useMemo(() => isSingleMode, [ isSingleMode ]);

  useEffect(() => {
    if (isPrefillValue) {
      setCashRefundAmount(refundTotalAmount);
    }
  }, [ isPrefillValue, refundTotalAmount ]);

  const {
    currencyCode,
    placeholder,
    handleFocus,
    handleBlur,
    handleChange,
  } = useCrurrencyInput({
    paymentMethodType, isPrefillValue, onChange: setCashRefundAmount,
  });

  const {
    pennyRoundingAmount,
  } = usePennyRounding([ cashRefundAmount, paymentMethodType, pennyRounding, currencyCode ]);

  const cashTotal = useMemo(() => {
    return amountSum(cashRefundAmount, pennyRoundingAmount);
  }, [ cashRefundAmount, pennyRoundingAmount ]);

  useEffect(() => {
    if (!isNil(pennyRoundingAmount) && !isNil(paymentMethodType)) {
      dispatch(updatePaymentsInfoUsedForPay({
        paymentInfoObj: {
          paymentMethodType,
          pennyRoundingAmount,
        },
        findPaymentConfig: { paymentMethodType },
      }));
    }
  }, [ pennyRoundingAmount, dispatch, paymentMethodType ]);

  return (
    <div className="multi-payment-cash">
      <div className="multi-payment-cash_input">
        <div className='label'>
          <Locale id="checkout.lib.components.text.refundAmount" />
        </div>
        <CurrencyInput
          codePosition="prefix"
          placeholder={placeholder}
          code={currencyCode}
          value={cashRefundAmount}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          disabled={isPrefillValue}></CurrencyInput>
      </div>
      {
        !!pennyRoundingAmount && <div className="flex-end cui-mg-t-20">
          <div className='penny-rounding'>
            <div className='penny-rounding__text-group'>
              <div className='penny-rounding__text'>
                <Locale id={'checkout.lib.components.text.pennyRounding'}></Locale>
              </div>
              <div className={classNames('penny-rounding__text', 'rounding-amount', {
                'red-amount': pennyRoundingAmount < 0,
              })} >
                <Currency amount={pennyRoundingAmount} code={currencyCode} />
              </div>
            </div>
            <div className='penny-rounding__text-group'>
              <strong className='penny-rounding__text'>
                <Locale id={'checkout.lib.components.text.cashTotal'}></Locale>
              </strong>
              <strong className='penny-rounding__text' >
                <Currency amount={cashTotal} code={currencyCode} />
              </strong>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default memo(Cash);
